/** Parse an HTTP Retry-After value into a safe, positive delay in seconds. */
export function retryAfterSeconds(value: string | null, now = Date.now()): number {
  if (!value) return 60;

  const seconds = Number(value);
  if (Number.isFinite(seconds) && seconds > 0) {
    return Math.ceil(seconds);
  }

  const retryAt = Date.parse(value);
  if (Number.isFinite(retryAt) && retryAt > now) {
    return Math.ceil((retryAt - now) / 1000);
  }

  return 60;
}
